import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// review-4.twig
import React from 'react';
import { Content, Headline, workshops, LazyImageAdapter } from '@miro-site/components_utils';
import { Box, Heading, Section } from '@miro-site/core';
import styled, { css, useTheme } from 'styled-components';
import { useLocalization } from '@miro-site/localization';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WORKSHOPS_BG_COLORS = workshops.WORKSHOPS_BG_COLORS;
var TestimonialBg = styled(Box).attrs({}).withConfig({
  displayName: "Testimonial__TestimonialBg",
  componentId: "sc-v53xgb-0"
})(["", ""], function (_ref) {
  var $background = _ref.$background,
      theme = _ref.theme;
  return $background && css(["background:", ";"], theme.colors[WORKSHOPS_BG_COLORS[$background]]);
});
var Row = styled(Box).attrs({
  $my: [null, 0],
  $mx: [null, -20]
}).withConfig({
  displayName: "Testimonial__Row",
  componentId: "sc-v53xgb-1"
})(["display:flex;flex-direction:row;flex-wrap:wrap;position:relative;z-index:3;"]);
var Col = styled(Box).attrs({
  $py: [0],
  $px: [20],
  $styles: {
    flex: [null, '0 0 66.66%']
  }
}).withConfig({
  displayName: "Testimonial__Col",
  componentId: "sc-v53xgb-2"
})([""]);
var ImageWrapper = styled(Box).attrs({
  $styles: {
    transform: ['translateX(0)', 'translateX(-50%)'],
    top: [-40, -46],
    bottom: [null, -46],
    right: [0, null],
    left: [0, '50%'],
    height: [360, null],
    width: [null, 1120]
  }
}).withConfig({
  displayName: "Testimonial__ImageWrapper",
  componentId: "sc-v53xgb-3"
})(["position:absolute;"]);
var ImageContainer = styled(Box).attrs({
  $styles: {
    transform: ['translateX(0)', 'translateY(-50%)'],
    top: [0, '50%'],
    left: [0, '58.31%'],
    position: ['relative', undefined],
    height: '100%',
    maxWidth: ['100%', null],
    width: ['100%', 500]
  }
}).withConfig({
  displayName: "Testimonial__ImageContainer",
  componentId: "sc-v53xgb-4"
})(["position:absolute;"]);
var TestimonialContainer = styled(Box).attrs({
  $pt: [336, 240],
  $pb: [96, 240],
  $px: 0,
  $styles: {
    maxWidth: [null, 1120],
    minHeight: [null, 800]
  }
}).withConfig({
  displayName: "Testimonial__TestimonialContainer",
  componentId: "sc-v53xgb-5"
})(["margin:auto;position:relative;", "{position:relative;", " &::after{content:'\u201D';}&::before{content:'\u201C';position:absolute;top:0;", "}&[lang='ja']{&:before{content:'\u300C';", "}&:after{content:'\u3002\u300D';}}}", ""], Heading, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    maxWidth: [null, 645]
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    left: [-17, -22]
  });
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.normalizeStyles({
    left: [-27, -32]
  });
}, function (_ref5) {
  var _ref5$$isRtl = _ref5.$isRtl,
      $isRtl = _ref5$$isRtl === void 0 ? false : _ref5$$isRtl,
      theme = _ref5.theme;
  return $isRtl && css(["", "{", "}", "{", "}"], Row, theme.normalizeStyles({
    left: [null, '33.33%'],
    paddingLeft: [null, 10]
  }), ImageContainer, theme.normalizeStyles({
    left: [0, '-14%']
  }));
});

var Testimonial = function Testimonial(_ref6) {
  var _ref6$background = _ref6.background,
      background = _ref6$background === void 0 ? 'workshops-color-pink' : _ref6$background,
      image = _ref6.image,
      headline = _ref6.headline,
      name = _ref6.name,
      post = _ref6.post,
      rtl = _ref6.rtl;
  var theme = useTheme();

  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale;

  return /*#__PURE__*/_jsx(Section, {
    "data-place": "Testimonial Section",
    type: "large",
    $styles: {
      overflow: 'hidden'
    },
    children: /*#__PURE__*/_jsx(TestimonialBg, {
      $background: background,
      children: /*#__PURE__*/_jsxs(TestimonialContainer, {
        $isRtl: rtl === 'true',
        children: [image && /*#__PURE__*/_jsx(ImageWrapper, {
          children: /*#__PURE__*/_jsx(ImageContainer, {
            children: /*#__PURE__*/_jsx(LazyImageAdapter, {
              assets: image
            })
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [headline && /*#__PURE__*/_jsx(Headline, _objectSpread(_objectSpread({}, headline), {}, {
              size: headline.size || 'small',
              tag: headline.tag || 'h3',
              color: workshops.isHighContrastColor(background) ? 'white' : undefined,
              headingProps: {
                lang: currentLocale,
                $styles: {
                  maxWidth: [null, 645]
                }
              }
            })), /*#__PURE__*/_jsxs(Box, {
              $mt: [theme.spaces.xl, theme.spaces.xxl],
              $styles: {
                maxWidth: [null, 550]
              },
              children: [name && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, name), {}, {
                color: workshops.isHighContrastColor(background) ? 'white' : 'dark',
                size: "large",
                weight: "bold",
                textProps: {
                  $styles: {
                    marginTop: [theme.spaces.xl, theme.spaces.xxl],
                    fontFamily: '"Spoof", sans-serif',
                    fontFeatureSettings: '"zero", "ss02", "ss05"'
                  }
                }
              })), post && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, post), {}, {
                color: workshops.isHighContrastColor(background) ? 'white' : 'dark'
              }))]
            })]
          })
        })]
      })
    })
  });
};

export default Testimonial;